import classNames from 'classnames'

export interface LinkProps extends React.ComponentPropsWithoutRef<'a'> {}

export const Link = ({ children, className, ...props }: LinkProps) => {
  return (
    <a className={classNames('content-teaser__link', className)} {...props}>
      {children}
    </a>
  )
}
